import api from '../utils/api';

/**
 * The archived half of the three lists whose Delete archives since 2026-10 (INV-128): lab results,
 * problem-list entries and files on a completed SOAP note. Their list routes hide archived rows
 * unless `includeArchived=true`; restoring is online-only.
 */
export type ArchivedKind = 'lab-results' | 'problem-list' | 'attachments';

export const clinicalArchiveService = {
  async listArchived<T extends { isArchived?: boolean }>(kind: ArchivedKind, horseId: string): Promise<T[]> {
    const res = await api.get(`/${kind}`, { params: { horseId, includeArchived: true } });
    const rows: T[] = Array.isArray(res.data) ? res.data : res.data?.data ?? [];
    return rows.filter((r) => r.isArchived);
  },

  async restore(kind: ArchivedKind, id: string): Promise<unknown> {
    const res = await api.post(`/${kind}/${id}/restore`);
    return res.data;
  },
};
